export default "__VITE_ASSET__DtI8gzx0__"